define((require) => {
    "use strict";

    const Window                                 = require("shared/services/Window");
    const {Logger}                                 = require("shared/util/Logger");
    const SalesforceCommerceQuickViewSiteGenesisStrategy = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStrategy");

    const log = new Logger("SalesforceCommerceQuickViewSiteGenesisStandardStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView Site Genesis Standard Strategy Class.
     * Available on Site Genesis version < 15.1 and on Site Genesis version >= 15.1 running in
     * compatibility mode with version < 15.1. No Zmags Creator cartridge needs to be installed on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisStandardStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Opens standard SalesforceCommerce QuickView function.
         * @param {String} productID - The product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         */
        open(productID, experienceName, currentScene) {
            const win = Window.topWindow();
            const url = Window.sandbox(["app.urls.getProductUrl", "app.URLs.getProductUrl"], win);
            const productURL = url + this.formatParameters(productID, experienceName, currentScene);

            Window.run({code: `app.quickView.show({source:"quickview", url:"${productURL}"})`, win});

            log.info(`Standard SalesforceCommerce QuickView launched for product: ${productID} on page: ${win.location.href}`);
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStandardStrategy.js